import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchClient } from "@/lib/api-client";

interface UseFetchMyFeedbackParams {
  limit?: number;
  enabled?: boolean;
}

export const useFetchMyFeedback = (params: UseFetchMyFeedbackParams = {}) => {
  const { limit = 20, enabled = true } = params;
  return useInfiniteQuery({
    queryKey: ["get", "/feedback/me", "infinite", limit],
    queryFn: async ({ pageParam }) => {
      const response = await fetchClient.GET("/feedback/me", {
        params: { query: { page: pageParam, limit } },
      });
      const error = response.error;
      if (error) throw error;
      return response.data;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const p = lastPage?.data?.pagination;
      return p?.hasNextPage ? p.page + 1 : undefined;
    },
    enabled,
  });
};
